const navs = [
    {
        name: 'Salesmen',
        route: '/users/4',
        icon: 'fa fa-users'
    },
    {
        name: 'Franchise Owner',
        route: '/franchise',
        icon: 'fa fa-user-circle-o'
    },
    {
        name: 'Products',
        route: '/products',
        icon: 'fa fa-product-hunt'
    },
    ,
    {
        name: 'Hot Looks',
        route: '/hotlooks',
        icon: 'fa fa-fire'
    },
    {
        name: 'Categories',
        route: '/categories',
        icon: 'fa fa-list'
    },
    {
        name: 'Uploaded Orders',
        route: '/uploaded-orders',
        icon: 'fa fa-file'
    },
    {
        name: 'Broadcasting',
        route: '/broadcast',
        icon: 'fa fa-bullhorn'
    },
    {
        name: 'Banners',
        route: '/banners',
        icon: 'fa fa-picture-o'
    },
    {
        name: 'Offers',
        route: '/offers',
        icon: 'fa fa-gift'
    },
    {
        name: 'Orders',
        route: '/orders',
        icon: 'fa fa-shopping-cart'
    },
    {
        name: 'Delivery',
        route: '/delivery',
        icon: 'fa fa-truck'
    },
    {
        name: 'Users',
        route: '/app-users',
        icon: 'fa fa-users'
    },
    {
        name: 'Version',
        route: '/addversion',
        icon: '	fa fa-cogs'
    },
    {
        name: 'Pincode',
        route: '/pincode',
        icon: 'fa fa-map-pin'
    },
    {
        name: 'Admins',
        route: '/users/1',
        icon: 'fa fa-user-plus'
    }
]

export default navs